import React from 'react'

import { Select, SelectProps } from '@mantine/core'

import { Severity } from '../types'

const SEVERITY_SELECTIONS: { value: number; label: string }[] = [
  { value: Severity.Debug, label: 'Debug' },
  { value: Severity.Info, label: 'Info' },
  { value: Severity.Warning, label: 'Warning' },
  { value: Severity.Critical, label: 'Critical' }
]

export const SeveritySelect: React.FC<Omit<SelectProps, 'data'>> = (props) => {
  return (
    <Select label='Severity' data={SEVERITY_SELECTIONS as any} {...props} />
  )
}
